var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.0078L2.25394 45.0003H51.8407L54.0947 40.0078H0Z",
    fill: "#80D4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3426 7.51758H6.74908C4.87831 7.51758 3.36816 9.02772 3.36816 10.8985V40.0082H50.7348V10.8985C50.7235 9.02772 49.2134 7.51758 47.3426 7.51758Z",
    fill: "#D2F0EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2307 12.0254H7.87988V35.5002H46.2307V12.0254Z",
    fill: "#A38FD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9019 9.78125H15.1904V35.4987H38.9019V9.78125Z",
    fill: "#7C64BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5721 3.38092L27.6547 0.101427C27.2603 -0.0338092 26.832 -0.0338092 26.4376 0.101427L16.5203 3.38092C15.7201 3.64012 15.1904 4.38392 15.1904 5.21788V17.5695C15.1904 20.1615 16.385 22.5958 18.4136 24.1961L25.4459 29.6957C26.3813 30.4282 27.6998 30.4282 28.6352 29.6957L35.6675 24.1961C37.7073 22.6071 38.8906 20.1615 38.8906 17.5695V5.22915C38.9019 4.39519 38.361 3.65139 37.5721 3.38092Z",
    fill: "#FBD872"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3775 5.6465V17.5811C36.3775 19.4068 35.5548 21.086 34.1236 22.2243L27.0913 27.7239L27.0462 27.7351C27.0236 27.7351 27.0124 27.7239 27.0124 27.7126L19.9688 22.213C18.5263 21.086 17.7148 19.3956 17.7148 17.5699V5.6465L27.0462 2.55859L36.3775 5.6465Z",
    fill: "#F38E7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 20.8381L20.375 16.7247L22.5726 14.5271L24.4997 16.4542L31.5207 9.42188L33.7183 11.6195L24.4997 20.8381Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandc);
export default __webpack_public_path__ + "static/media/sandc.595d1d40babe24ea339d5436f80ef221.svg";
export { ForwardRef as ReactComponent };